// import { Howl, Howler } from ''
import { Howl, Howler } from 'howler';
import SoundTrack from '../data/notification-sound.mp3';

export const play_audio = () => {
    const sound = new Howl({
        src: SoundTrack
    });
    sound.play();
}